import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
    useDisclosure,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Text,
    Icon,
    IconButton
} from '@chakra-ui/react';
import LandClass, { RoleClass } from '../../../core/land/landClass';
import { DataContext } from '../../../core/contexts';
import { AnimalClass } from '../../../core/animal';
import { DeleteIcon } from '@chakra-ui/icons';

export default function DeleteModal(props: {
    service: any;
    beforeClose?: Function;
    data?: any;
    size?: string;
    as: 'button' | 'icon';
}): React.ReactElement {
    const { t } = useTranslation();
    const { landId } = useParams();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { getLand } = useContext(DataContext);
    const [role, setRole] = useState<RoleClass>();
    const [deleting, setDeleting] = useState<boolean>(false);

    const onSubmit = async (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        props.service.remove
            ? await props.service.remove(props.data.id)
            : await props.service.delete(props.data.id);
        props.beforeClose && props.beforeClose();
        onClose();
    };

    useEffect(() => {
        if (!props.data) return;
        const land = (
            landId
                ? getLand(landId)
                : getLand((props.data as AnimalClass).landData.id)
        ) as LandClass;

        setRole(land.getLoggedRole());
    }, []);

    return (
        <>
            {props.as === 'button' && (
                <Button
                    w='full'
                    size={props.size || 'md'}
                    colorScheme='red'
                    onClick={onOpen}
                >
                    {t('form.delete')}
                </Button>
            )}

            {props.as === 'icon' && (
                <IconButton
                    size={props.size || 'sm'}
                    colorScheme='red'
                    variant='outline'
                    aria-label='Delete'
                    icon={<Icon as={DeleteIcon} />}
                    onClick={onOpen}
                />
            )}

            <Modal isOpen={isOpen} onClose={onClose} size='sm' isCentered>
                <ModalOverlay />
                <ModalContent>
                    {/* <ModalHeader>{isEdit ? 'Editar datos de la finca' : 'Crear finca'}</ModalHeader> */}
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize='3xl' align='center' p='2' pt='10'>
                            {t('modal.confirmDelete')}
                        </Text>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            colorScheme='orange'
                            variant='outline'
                            mr={3}
                            onClick={onClose}
                        >
                            {t('form.close')}
                        </Button>
                        <Button
                            colorScheme='red'
                            onClick={onSubmit}
                            isLoading={deleting}
                        >
                            {t('form.delete')}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}
